<template>
  <section class="blog-grid" :style="sectionStyles">
    <div class="container">
      <!-- Optional Fold Image -->
      <div v-if="shopifyData.foldImage" class="fold-image-container">
        <img
          :src="shopifyData.foldImage"
          alt="Behno New York - In Conversations"
          class="fold-image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Fold Image"
          width=""
          height=""
        />
      </div>

      <!-- Featured Article (Full Width) -->
      <!--
      <div v-if="shopifyData.featuredArticle" class="featured-article-container">
        <div class="article-meta featured-meta mobile-tablet-only">
          <span class="article-label">{{ shopifyData.featuredArticle.label || 'EDITOR\'S PICK' }}</span>
        </div>
        <div class="featured-article">
          <a :href="shopifyData.featuredArticle.url" class="featured-link">
            <div class="featured-image-container">
              <img
                  :src="shopifyData.featuredArticle.image || 'https://cdn.shopify.com/s/files/1/0577/1178/8125/products/AnaLargeBlack.jpg?v=1653725720'"
                  :alt="shopifyData.featuredArticle.title"
                  class="featured-image"
              />
            </div>
            <div class="featured-content">
              <div class="article-meta featured-meta desktop-only">
                <span class="article-label">{{ shopifyData.featuredArticle.label || 'EDITOR\'S PICK' }}</span>
              </div>
              <span class="article-date">{{ shopifyData.featuredArticle.date }}</span>
              <h2 class="featured-title" v-html="shopifyData.featuredArticle.title"></h2>
              <p class="featured-excerpt" v-html="shopifyData.featuredArticle.excerpt"></p>
            </div>
          </a>
        </div>
      </div>
      -->

      <!-- All Posts Heading (mobile only) -->
      <h2 class="all-posts-heading mobile-only">ALL POSTS</h2>
      <!-- Articles Grid (3x2) -->
      <div class="articles-grid">
        <div class="articles-grid-container">
          <div ref="gridTop" class="articles-grid-1">
            <article
              v-for="(article, index) in paginatedArticles.slice(0, 3)"
              :key="index"
              class="article-card"
            >
              <a :href="article.url" class="article-link">
                <div class="article-image-container">
                  <img
                    :src="
                      article.image ||
                      'https://cdn.shopify.com/s/files/1/0577/1178/8125/products/ELIZBAETHBAGUETTEMININAPPABLACKFRONT.jpg?v=1653725160'
                    "
                    :alt="article.title"
                    class="article-image"
                    loading="lazy"
                    aria-hidden="true"
                    aria-label="Article Image"
                    width=""
                    height=""
                  />
                </div>
                <div class="article-content">
                  <span class="article-date">{{ article.date }}</span>
                  <h3 class="article-title" v-html="article.title" />
                  <p class="article-excerpt" v-html="article.excerpt" />
                </div>
              </a>
            </article>
          </div>
          <div class="articles-grid-2">
            <article
              v-for="(article, index) in paginatedArticles.slice(3, 6)"
              :key="index + 3"
              class="article-card"
            >
              <a :href="article.url" class="article-link">
                <div class="article-image-container">
                  <img
                    :src="
                      article.image ||
                      'https://cdn.shopify.com/s/files/1/0577/1178/8125/products/ELIZBAETHBAGUETTEMININAPPABLACKFRONT.jpg?v=1653725160'
                    "
                    :alt="article.title"
                    class="article-image"
                    loading="lazy"
                    aria-hidden="true"
                    aria-label="Article Image"
                    width=""
                    height=""
                  />
                </div>
                <div class="article-content">
                  <span class="article-date">{{ article.date }}</span>
                  <h3 class="article-title" v-html="article.title" />
                  <p class="article-excerpt" v-html="article.excerpt" />
                </div>
              </a>
            </article>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div v-if="totalPages > 1" class="pagination">
      <a
        href="#"
        class="pagination-arrow prev"
        :class="{ disabled: currentPage === 1 }"
        @click.prevent="goToPrevPage"
        >&lt;</a
      >
      <div class="pagination-numbers">
        <a
          v-for="page in totalPages"
          :key="page"
          href="#"
          :class="['pagination-number', { active: page === currentPage }]"
          @click.prevent="goToPage(page)"
        >
          {{ page }}
        </a>
      </div>
      <a
        href="#"
        class="pagination-arrow next"
        :class="{ disabled: currentPage === totalPages }"
        @click.prevent="goToNextPage"
        >&gt;</a
      >
    </div>
  </section>
</template>

<script>
export default {
  // name: 'BlogGrid',
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 6,
    };
  },
  computed: {
    sectionStyles() {
      return {
        backgroundColor: this.shopifyData.bgColor || '#fff',
        paddingTop:
          window.innerWidth > 768
            ? (this.shopifyData.deskPaddingTop || '60') + 'px'
            : (this.shopifyData.mobPaddingTop || '40') + 'px',
        paddingBottom:
          window.innerWidth > 768
            ? (this.shopifyData.deskPaddingBottom || '60') + 'px'
            : (this.shopifyData.mobPaddingBottom || '40') + 'px',
      };
    },
    filteredArticles() {
      // Return all articles sorted by date descending
      if (!this.shopifyData.articles) return [];
      return [...this.shopifyData.articles].sort((a, b) => {
        const dateA = new Date(a.date || a.published_at || 0);
        const dateB = new Date(b.date || b.published_at || 0);
        return dateB - dateA;
      });
    },
    totalPages() {
      return Math.ceil(this.filteredArticles.length / this.pageSize) || 1;
    },
    paginatedArticles() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredArticles.slice(start, start + this.pageSize);
    },
  },
  mounted() {
    // Debug logging to check for duplicates
    // console.log('🔍 Featured Article:', this.shopifyData.featuredArticle?.title);
    // console.log(
    //   '🔍 Original Grid Articles:',
    //   this.shopifyData.articles?.map((a) => a.title)
    // );
    // console.log(
    //   '🔍 Filtered Grid Articles:',
    //   this.filteredArticles?.map((a) => a.title)
    // );

    // Check for duplicates in original data
    if (this.shopifyData.featuredArticle && this.shopifyData.articles) {
      const duplicates = this.shopifyData.articles.filter(
        (article) => article.title === this.shopifyData.featuredArticle.title
      );
      if (duplicates.length > 0) {
        console.warn(
          '⚠️ DUPLICATE ARTICLES FOUND (now filtered out):',
          duplicates.map((d) => d.title)
        );
      } else {
        console.log('✅ No duplicates found');
      }
    }
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        // Scroll to top of section for better UX
        if (this.$refs.gridTop) {
          this.$refs.gridTop.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    goToPrevPage() {
      this.goToPage(this.currentPage - 1);
    },
    goToNextPage() {
      this.goToPage(this.currentPage + 1);
    },
  },
};
</script>

<style scoped>
.blog-grid {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;
}

.container {
  display: flex;
  width: 100%;
  max-width: 1380px;
  margin: 0 auto;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;
}

/* Featured Article */
.featured-article {
  display: flex;
  /*width: 1380px;*/
  height: 509px;
  align-items: center;
  gap: 18px;
}

.featured-article-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}

.featured-link {
  display: flex;
  gap: 18px;
  text-decoration: none;
  color: inherit;
  align-items: center; /* Change from flex-start to center */
  width: 100%;
  height: 100%;
}

.featured-image-container {
  height: 509px;
  flex: 0 0 50%;
  width: 50%;
}

.featured-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.featured-meta {
  margin-bottom: 15px;
}

.featured-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; /* Add this to center content vertically */
  gap: 12px;
  flex: 0 0 50%;
  width: 50%;
  height: 100%; /* Make sure it takes full height */
}

.article-meta {
  margin-bottom: 15px;
}

.article-label {
  color: #000;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 15px; /* 125% */
  letter-spacing: 0.24px;
  text-transform: uppercase;
}

.featured-article .article-date {
  color: #000;
  font-family: 'Adobe Caslon Pro', Georgia, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
}

.featured-title {
  align-self: stretch;
  color: #000;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 120% */
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.featured-excerpt {
  overflow: hidden;
  color: #000;
  text-overflow: ellipsis;
  font-family: 'Adobe Caslon Pro', Georgia, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  align-self: stretch;
}

/* Articles Grid */
.articles-grid {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  align-self: stretch;
}

.articles-grid-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  align-self: stretch;
}

.articles-grid-1 {
  display: flex;
  align-items: flex-start;
  gap: 50px;
  align-self: stretch;
  justify-content: flex-start;
}

.articles-grid-2 {
  display: flex;
  align-items: flex-start;
  gap: 50px;
  align-self: stretch;
  justify-content: flex-start;
}

.article-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 0 0 auto;
  width: calc(33.333% - 33.333px); /* Fixed width for 3 columns with gaps */
  max-width: 426px;
}

.article-link {
  display: block;
  text-decoration: none;
  color: inherit;
}

.article-image-container {
  height: 426.667px;
  width: 100%;
  margin-bottom: 12px;
}

.article-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.article-content {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.article-date {
  align-self: stretch;
  color: #000;
  font-family: 'Adobe Caslon Pro', Georgia, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
}

.article-title {
  color: #000;
  align-self: stretch;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 120% */
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.article-excerpt {
  overflow: hidden;
  color: #000;
  text-overflow: ellipsis;
  font-family: 'Adobe Caslon Pro', Georgia, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  align-self: stretch;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
  width: 100%;
}

.pagination-numbers {
  display: flex;
  width: auto;
  padding: 8px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.pagination-number {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #000;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: 18px; /* 120% */
  letter-spacing: 0.3px;
  text-transform: capitalize;
}

.pagination-number.active {
  background-color: #000000;
  color: #ffffff;
}

.pagination-arrow {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #000;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: 18px; /* 120% */
  letter-spacing: 0.3px;
  text-transform: capitalize;
}

.pagination-arrow.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive label positioning */
.article-meta.desktop-only {
  display: block !important;
  margin-bottom: 0;
}

.article-meta.mobile-tablet-only {
  display: none !important;
}

/* All Posts mobile heading */
.all-posts-heading {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin: 0;
}

.mobile-only {
  display: none;
}

@media (max-width: 1024px) {
  .mobile-only {
    display: block;
  }
  .all-posts-heading {
    margin-bottom: 10px;
  }
}

/* Responsive Design */
@media (max-width: 1200px) {
  .container {
    max-width: 100%;
    padding: 0 30px;
  }

  .featured-link {
    gap: 15px;
  }

  .articles-grid-1,
  .articles-grid-2 {
    gap: 30px;
  }

  .article-card {
    width: calc(33.333% - 20px);
  }
}

@media (max-width: 1024px) {
  .container {
    padding: 0 20px;
  }

  .featured-link {
    flex-direction: column;
    gap: 20px;
    height: auto;
  }

  .featured-image-container {
    flex: none;
    width: 100%;
    height: 400px;
  }

  .featured-content {
    height: auto;
    padding: 0 20px;
  }

  .articles-grid-1,
  .articles-grid-2 {
    gap: 25px;
    justify-content: center;
  }

  .article-card {
    width: calc(33.333% - 20px);
    max-width: 426px;
  }

  .article-image-container {
    height: 100%;
  }
}

@media (max-width: 768px) {
  .article-meta.desktop-only {
    display: none !important;
  }

  .article-meta.mobile-tablet-only {
    display: block !important;
  }

  .container {
    padding: 0 15px;
    gap: 40px;
  }

  .featured-image-container {
    height: 300px;
  }

  .featured-content {
    padding: 0;
  }

  .featured-title {
    font-size: 14px;
    line-height: 16px;
  }

  .featured-excerpt {
    font-size: 13px;
    line-height: 18px;
  }

  .articles-grid-container {
    gap: 30px;
  }

  .articles-grid-1,
  .articles-grid-2 {
    flex-direction: column;
    gap: 30px;
    align-items: center;
  }

  .article-card {
    width: 100%;
    max-width: 400px;
    margin: 0;
  }

  .article-image-container {
    height: 100%;
  }

  .article-title {
    font-size: 14px;
    line-height: 16px;
  }

  .article-excerpt {
    font-size: 13px;
    line-height: 18px;
  }

  .pagination {
    margin-top: 40px;
  }
}

@media (max-width: 480px) {
  .article-meta.desktop-only {
    display: none !important;
  }

  .article-meta.mobile-tablet-only {
    display: block !important;
  }

  .container {
    padding: 0 15px;
    gap: 30px;
  }

  .featured-article {
    height: auto;
  }

  .featured-image-container {
    height: 250px;
  }

  .featured-content {
    padding: 0;
  }

  .featured-title {
    font-size: 13px;
    line-height: 15px;
  }

  .featured-excerpt {
    font-size: 12px;
    line-height: 16px;
    -webkit-line-clamp: 2;
  }

  .articles-grid-container {
    gap: 25px;
  }

  .articles-grid-1,
  .articles-grid-2 {
    gap: 25px;
  }

  .article-card {
    max-width: 100%;
    margin: 0;
  }

  .article-image-container {
    height: 100%;
  }

  .article-title {
    font-size: 13px;
    line-height: 15px;
  }

  .article-excerpt {
    font-size: 12px;
    line-height: 16px;
  }

  .article-date {
    font-size: 12px;
  }

  .pagination {
    margin-top: 30px;
  }
}

/* Fold Image */
.fold-image-container {
  width: 100%;
  height: auto;
}

.fold-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}
</style>
